import { VoiceControlsContainer, VoiceDevicesList } from "./components";
import {
  devicesLoaded,
  getDevices,
  getDevicesFailed,
  getUserDevices,
} from "../redux/devices-slice";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "../components";
import { CSS_SIZE_SM } from "../constants/constants";
import Media from "react-media";
import cn from "classnames";
import { devicesError } from "./MyDevicesPage.module.scss";
import sharedStyles from "../shared.module.scss";
import styles from "./VoiceConfigPage.module.scss";
import { useEffect } from "react";
import { useFormatMessage } from "../i18n";

export function VoiceConfigPage() {
  const tr = useFormatMessage();
  const dispatch = useDispatch();
  const devices = useSelector(getDevices);
  const devicesLoadingFailed = useSelector(getDevicesFailed);
  const initialLoadSuccessfull = useSelector(devicesLoaded);

  useEffect(() => {
    dispatch(getUserDevices());
  }, [dispatch]);

  return (
    <div className={cn(sharedStyles.content, styles.voiceConfigPage)}>
      <div className={cn(sharedStyles.headerContainer, sharedStyles.content)}>
        <h1 className={sharedStyles.pageTitle}>{tr("voice_control")}</h1>
      </div>
      {devicesLoadingFailed && !initialLoadSuccessfull ? (
        <Alert severity="error" className={devicesError}>
          {tr("fail_getting_devices")}
        </Alert>
      ) : (
        <Media query={`(max-width: ${CSS_SIZE_SM}px)`}>
          {(isMobile) =>
            isMobile ? (
              <VoiceDevicesList devices={devices} />
            ) : (
              <div
                className={cn(
                  styles.voiceConfigMenu,
                  sharedStyles.secondaryText
                )}
              >
                <VoiceDevicesList
                  devices={devices}
                  className={styles.voiceConfigPanel}
                />
                <VoiceControlsContainer className={styles.voiceConfigPanel} />
              </div>
            )
          }
        </Media>
      )}
    </div>
  );
}
